import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  entityTypes: [
    { name: 'CARDINAL', color: '#f6c2d9' },
    { name: 'DATE', color: '#F50006' },
    { name: 'EVENT', color: '#aed143' },
    { name: 'FAC', color: '#f49f3f' },
    { name: 'GPE', color: '#a1c8e9' },
    { name: 'LANGUAGE', color: '#FC8181' },
    { name: 'LAW', color: '#FEB2B2' },
    { name: 'LOC', color: '#A0AEC0' },
    { name: 'MONEY', color: '#9F7AEA' },
    { name: 'NORP', color: '#718096' },
    { name: 'ORDINAL', color: '#68D391' },
    { name: 'ORG', color: '#38B2AC' },
    { name: 'PERCENT', color: '#ED8936' },
    { name: 'PERSON', color: '#5A67D8' },
    { name: 'PRODUCT', color: '#805AD5' },
    { name: 'QUANTITY', color: '#B83280' },
    { name: 'TIME', color: '#2F855A' },
    { name: 'WORK_OF_ART', color: '#ED64A6' },
  ]
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
